import { List, Text } from '@ksyos/design-system';
import { useState } from 'react';
import { connect } from 'react-redux';
import type { IReduxState } from '../../../configureStore';
import { translateKey } from '../../../translate';
import { ChapterTitle } from '../../elements/atoms/chapterTitle/ChapterTitle';
import { PageTitle } from '../../elements/atoms/pageTitle/PageTitle';
import { Article } from '../../elements/molecules/article/article';
import { Container } from '../../elements/molecules/container/Container';
import { Content } from '../../elements/molecules/content/Content';
import { DropdownLink } from '../../elements/molecules/dropdownLink/DropdownLink';
import { FormDivider } from '../../elements/molecules/formDivider/FormDivider';
import { Main } from '../../elements/molecules/main/Main';
import { PageSection } from '../../elements/molecules/pageSection/PageSection';
import { CollapseBody } from '../../elements/organisms/collapseBody/CollapseBody';
import { Footer } from '../../elements/organisms/footer/Footer';
import { Header } from '../../elements/organisms/header/Header';
import { PageWrapper } from '../../elements/organisms/pageWrapper/PageWrapper';

interface IGhcInformationReduxProps {
    canCreateGhcConsult: boolean;
}

const mapStateToProps = ({ authentication }: IReduxState): IGhcInformationReduxProps => ({
    canCreateGhcConsult: authentication.permissions?.canCreateGhcConsult || false,
});

function GhcInformationWrapper() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <PageWrapper>
            <Header
                backButtonText={translateKey('common.home')}
                backUrl="/"
                hasBackbutton
                hasLogoutButton
            />
            <Main>
                <Container isFluidOnMobile>
                    <PageSection>
                        <Article>
                            <PageTitle>Hoe werkt het?</PageTitle>
                        </Article>
                    </PageSection>

                    <PageSection bgColor="white">
                        <Article>
                            <ChapterTitle>Het Ksyos Thuisconsult in het kort </ChapterTitle>
                            <List>
                                <List.Item icon="healthcare-institution">Een volwaardig medisch consult</List.Item>
                                <List.Item icon="counseling">Waar je ook bent, makkelijk online</List.Item>
                                <List.Item icon="honoraria">Kosteloos via de meeste zorgverzekeraars</List.Item>
                            </List>
                        </Article>

                        <FormDivider />

                        <CollapseBody isOpen={isOpen}>
                            <Article>
                                <ChapterTitle>Een volwaardig medisch consult</ChapterTitle>
                                <Text>
                                    De huisarts bekijkt je situatie en kan een medisch specialist uit het ziekenhuis
                                    vragen om digitaal mee te kijken. Zo voorkomen we dat jij naar de huisarts praktijk
                                    moet of in de wachtrij komt voor een afspraak met een medisch specialist.
                                </Text>

                                <ChapterTitle>Waar je ook bent, makkelijk online</ChapterTitle>
                                <Text>
                                    Je kan op elke computer, telefoon of tablet inloggen bij MijnKsyos met DigiD via
                                    jouw webbrowser.
                                </Text>

                                <ChapterTitle>Kosteloos via de meeste zorgverzekeraars</ChapterTitle>
                                <Text>
                                    Bij de meeste zorgverzekeringen geldt voor het Thuisconsult geen eigen risico.
                                    (Uitgezonderd DSW)
                                </Text>
                            </Article>
                        </CollapseBody>

                        {isOpen && <FormDivider />}

                        <DropdownLink
                            labelLess={'Klap de details in'}
                            labelMore={'Bekijk de details'}
                            onClick={async () => setIsOpen(!isOpen)}
                            open={isOpen}
                        />
                    </PageSection>

                    <PageSection bgColor="white">
                        <Article>
                            <ChapterTitle>Een consult in vier stappen</ChapterTitle>
                            <Content className="ml-3">
                                <List styleType="counter">
                                    <List.Item>Je huisarts stuurt je via MijnKsyos een aantal vragen.</List.Item>
                                    <List.Item>Je beantwoordt de vragen.</List.Item>
                                    <List.Item>
                                        Je huisarts bekijkt je situatie en bespreekt deze mogelijk met een specialist.
                                    </List.Item>
                                    <List.Item>
                                        Wanneer je huisarts reageert ontvang je een e-mail en zal je huisarts je bellen
                                        om je situatie te bespreken. Houd je telefoon bij de hand.
                                    </List.Item>
                                </List>
                            </Content>
                        </Article>
                    </PageSection>
                </Container>
            </Main>
            <Footer />
        </PageWrapper>
    );
}

export const GhcInformation = connect(mapStateToProps)(GhcInformationWrapper);
